module.exports = __webpack_public_path__ + "static/media/TN-Men-Outer.f05a0f04.svg";